import * as React from 'react'

export class PencilIcon extends React.Component<
  { w: number; h: number; fill: string } & React.SVGAttributes<SVGElement>,
  {}
> {
  public render() {
    const { w, h, fill, ...props } = this.props

    return (
      <svg
        version="1.1"
        width={w}
        height={h}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          fill={fill}
          d="M21 6.879l-3.879-3.879c-0.293-0.293-0.678-0.439-1.061-0.439-0.384 0-0.767 0.146-1.060 0.439l-10.939 10.939c-0.293 0.293-0.558 0.727-0.75 1.188-0.192 0.463-0.311 0.959-0.311 1.373v4.5h4.5c0.414 0 0.908-0.119 1.371-0.311s0.896-0.457 1.189-0.75l10.94-10.939c0.293-0.293 0.439-0.678 0.439-1.061 0-0.384-0.146-0.767-0.439-1.060zM5.768 15.061l8.293-8.293 1.232 1.232-8.293 8.293-1.232-1.232zM7.5 19h-1.5l-1-1v-1.5c0-0.077 0.033-0.305 0.158-0.605 0.010-0.020 2.967 2.938 2.967 2.938-0.322 0.134-0.548 0.167-0.625 0.167zM8.939 18.232l-1.232-1.232 8.293-8.293 1.232 1.232-8.293 8.293zM17.939 9.232l-3.172-3.172 1.293-1.293 3.17 3.172-1.291 1.293z"
        />
      </svg>
    )
  }
}
